import React from 'react';
import './Legacy.css';
import legacyImg from '../../../../assets/images/legacy/legacy.webp';
import { Link } from 'react-router-dom';

const Legacy = () => {
  return (
    <section className="legacy">
      <div className="legacy-container">

        <div className="legacy-left">
          <h2>
            A Legacy of Industry <br />
            <span>Since 1998</span>
          </h2>

          <p>
            The API project builds on a long-standing industrial foundation. The
            facility originally operated as Al-Anam Factory in 1998 and is now
            being transformed into a state-of-the-art pharmaceutical manufacturing
            complex serving Iraq and the region.
          </p>

          <Link to="/about" className="legacy-btn">About us</Link>
        </div>

        <div className="legacy-right">
          <img src={legacyImg} alt="legacy" />
        </div>

      </div>
    </section>
  );
};

export default Legacy;